import React from 'react';
import { History } from '@mui/icons-material';
import ReportLayout from '../Components/Reports/ReportLayout';

interface TypeReportProps {
  Entete: string;
  TypeGroup: string;
}

const FRHistoCompte: React.FC<TypeReportProps> = ({ Entete, TypeGroup }) => {
  return (
    <ReportLayout
      title={Entete}
      subtitle="Historique compte"
      icon={<History />}
      endpoint="transaction-histocompte"
      extraParams={{ Type: TypeGroup || 'Historique' }}
      showClientRange={false}
      showDateRange={true}
      showAgence={false}
      loadAgenceData={true}
      extraFields={[
        { key: 'NumCli', label: 'Numero client', type: 'text' },
        {
          key: 'NumCpt',
          label: 'Compte',
          type: 'select',
          fetchUrl: 'compte-bynumcli',
          dependsOn: 'NumCli',
          dependsOnParam: 'Numcli',
          valueField: 'NumCpt',
          labelField: 'NomCpt',
        },
      ]}
      paramTransform={(params, { dynamicOptions, agenceData }) => {
        const selectedCompte = (dynamicOptions['NumCpt'] || []).find(
          (opt) => opt.value === params.NumCpt
        );
        const CodAgce2 = selectedCompte?.raw?.AgcCpt || '';
        const agenceInfo = agenceData.find((b) => String(b.CodeAgence) === CodAgce2);
        return {
          ...params,
          CodAgce2,
          Libelle: agenceInfo?.Libelle || '',
          Banque: agenceInfo?.Banque || '',
          Teleph: agenceInfo?.Telephone || '',
          NumReg: agenceInfo?.NumReg || '',
          Licence: agenceInfo?.Licence || '',
          NumCon: agenceInfo?.Licence || '',
          BPoste: agenceInfo?.BPoste || '',
          Ville: agenceInfo?.Ville || '',
        };
      }}
      fileNamePrefix="rapport_histo_compte"
    />
  );
};

export default FRHistoCompte;
